import type { AppDispatch } from '../store';
import type { AchievementState, ReduxAction } from '../types/common';

const achievementReducer = (state: AchievementState = { list: null, loading: false, error: null }, action: ReduxAction<unknown>): AchievementState => {
  switch (action.type) {
    case 'FETCH_ACHIEVEMENTS_START':
      return { ...state, loading: true, error: null };
    case 'FETCH_ACHIEVEMENTS_SUCCESS':
      return { list: action.payload as unknown[], loading: false, error: null };
    case 'FETCH_ACHIEVEMENTS_FAIL':
      return { list: null, loading: false, error: String(action.payload ?? 'Unknown error') };
    default:
      return state;
  }
};

export const fetchAchievementsForUser = (username: string, isOwnProfile: boolean) => {
  return async (dispatch: AppDispatch) => {
    dispatch({ type: 'FETCH_ACHIEVEMENTS_START' });
    try {
      const achievementService = ((await import('../services/achievements')) as any).default;
      const data = isOwnProfile
        ? await achievementService.getMyAchievements()
        : await achievementService.getUserAchievements(username);
      dispatch({ type: 'FETCH_ACHIEVEMENTS_SUCCESS', payload: data });
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : String(err);
      dispatch({
        type: 'FETCH_ACHIEVEMENTS_FAIL',
        payload: errorMessage,
      });
    }
  };
};

export default achievementReducer;
